module.exports = __webpack_public_path__ + "b883ad6973dcd6f6069c75b95a8816dd.jpg";